export default {
  namespaced: true,
  state: {
    lasLessons: []
  },
  mutations: {
    setLastLessons(state, lasLessons) {
      state.lasLessons = lasLessons;
    }
  },
  actions: {
    getLastLessons(context) {
      return new Promise((resolve, reject) => {
        window.axios
          .get("/students/progress")
          .then(response => {
            context.commit("setLastLessons", response.data);
            resolve();
          })
          .catch(reject);
      });
    },
    setProgress(context, data) {
      return new Promise((resolve, reject) => {
        window.axios
          .post("/students/progress", data)
          .then(resolve)
          .catch(reject);
      });
    }
  }
};
